import React from 'react';
import { withStyles } from '@material-ui/core';

const styles = (theme: any) => ({
  timelineMetricItem: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'flex-start',
    minWidth: 0,
    marginRight: 8,
    '&:last-child': {
      marginRight: 0
    }
  },
  timelineMetricValue: {
    fontSize: 12,
    fontWeight: 600,
    color: theme.TextColor,
    marginBottom: 2
  },
  timelineMetricLabel: {
    fontSize: 10,
    color: theme.gridTextColor
  }
});

interface TimelineMetricProps {
  classes: Record<string, string>;
  value: string | number;
  label: string;
}

const TimelineMetric: React.FC<TimelineMetricProps> = ({ classes, value, label }) => (
  <div className={classes.timelineMetricItem}>
    <span className={classes.timelineMetricValue}>{value}</span>
    <span className={classes.timelineMetricLabel}>{label}</span>
  </div>
);

export default withStyles(styles)(TimelineMetric);
